export default __webpack_public_path__ + "static/media/bg-home.cb8b1e76.jpg";